var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon24PxTargetArrowOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1758 12.7298C21.0361 14.4856 20.3952 16.1644 19.3292 17.5667C18.2632 18.9691 16.8171 20.036 15.1623 20.6407C13.5077 21.2455 11.7142 21.3627 9.99493 20.9784C8.27564 20.594 6.70284 19.7243 5.46339 18.4726C4.22393 17.2209 3.36991 15.6398 3.00279 13.9171C2.63568 12.1944 2.7709 10.4026 3.39239 8.75444C4.01388 7.10633 5.09552 5.67122 6.50879 4.61961C7.92207 3.568 9.60758 2.94409 11.3651 2.82202",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9532 13.5423C15.6976 14.2001 15.282 14.7839 14.744 15.2408C14.206 15.6977 13.5626 16.0133 12.8719 16.1591C12.1813 16.3049 11.4652 16.2763 10.7884 16.0758C10.1116 15.8753 9.49551 15.5093 8.99574 15.0109C8.49599 14.5125 8.12835 13.8974 7.92611 13.2212C7.72385 12.545 7.69336 11.8291 7.83738 11.1381C7.98142 10.4472 8.29542 9.80306 8.75099 9.26397C9.20656 8.72487 9.78935 8.30783 10.4466 8.05054",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.9999L15.5389 8.46143",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.369 9.16933L15.5379 8.46163L14.8301 5.63084L17.6612 2.80005L18.369 5.63084L21.2001 6.33854L18.369 9.16933Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24PxTargetArrowOutline);
export default __webpack_public_path__ + "static/media/icon_24px_target-arrow_outline.4c272caec98c0f37eb17577fef4fcb2e.svg";
export { ForwardRef as ReactComponent };